import { render, staticRenderFns } from "./DeliverGoodsVanTabContent.vue?vue&type=template&id=27ebab96&scoped=true"
import script from "./DeliverGoodsVanTabContent.vue?vue&type=script&lang=js"
export * from "./DeliverGoodsVanTabContent.vue?vue&type=script&lang=js"
import style0 from "./DeliverGoodsVanTabContent.vue?vue&type=style&index=0&id=27ebab96&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ebab96",
  null
  
)

export default component.exports